/**
 * @file
 * Behaviors for the Card List.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Card List behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.cardList = {
    attach: function() {
      // We're setting up our carousels on mobile only
      let winWidth = $(window).width();
      const mobileBp = 480;

      if (winWidth <= mobileBp) {
        // Targeting all of our card lists
        const containers = $('.mss-card-list');
        for (let i = 0; i < containers.length; i++) {
          // get the height of the first card item in each card list
          let firstItemHeight = containers
            .eq(i)
            .find('.mss-card-list__items > .mss-card-list__item:first-of-type')
            .outerHeight();
          // add some extra room so the cards aren't squished in the carousel
          let newHeight = firstItemHeight + 30;
          // all of the rest of the cards need their heights adjusted
          let itemsToUpdate = containers
            .eq(i)
            .find('.mss-card-list__items > .mss-card-list__item');
          // adjusting their heights to the new value
          for (let j = 0; j < itemsToUpdate.length; j++) {
            itemsToUpdate.eq(j).outerHeight(newHeight);
          }
        }
      }
    }
  };
})(Drupal, jQuery);
